var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "coupon-category-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "15px" },
    },
    [
      _vm.chartsData && _vm.chartsData.length > 0
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "abow_dialog",
              attrs: {
                "append-to-body": "",
                "modal-append-to-body": "",
                visible: _vm.dialogSatisfactionChatAnalysisVisible,
                width: "95%",
                top: "1%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogSatisfactionChatAnalysisVisible = $event
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "dialog-header-container" },
                          [
                            _c("span", { staticClass: "el-dialog__title" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.currentSatisfactionAnalysis.title +
                                      " 滿意度圖表分析(百分比)"
                                  ) +
                                  " "
                              ),
                            ]),
                            _c(
                              "el-button",
                              {
                                staticClass: "download-pdf-btn",
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  icon: "el-icon-download",
                                },
                                on: {
                                  click: _vm.exportAnalysisHistogramCahtsToPDF,
                                },
                              },
                              [_vm._v(" 下載PDF報告 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                620946230
              ),
            },
            [
              _c(
                "div",
                { ref: "analysisHistogramCahtsRef" },
                [
                  _vm._l(_vm.chartsData, function (chartData, index) {
                    return [
                      _c(
                        "div",
                        { key: index },
                        [
                          _c("analysis-histogram-caht", {
                            attrs: {
                              page: chartData.pageNumber,
                              legendData: chartData.legendData,
                              xAxisData: chartData.xAxisData,
                              seriesData: chartData.seriesData,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  }),
                  [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "20px" } },
                      [
                        _c("analysis-bar-caht", {
                          attrs: {
                            satisfactionAnalysis: _vm.satisfactionAnalysis,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm.currentSatisfactionAnalysis
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "abow_dialog",
              attrs: {
                "append-to-body": "",
                "modal-append-to-body": "",
                visible: _vm.dialogSatisfactionAnalysisVisible,
                width:
                  _vm.currentSatisfactionAnalysis.options.length <= 3
                    ? "60%"
                    : "85%",
                top: "1%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogSatisfactionAnalysisVisible = $event
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "dialog-header-container" },
                          [
                            _c("span", { staticClass: "el-dialog__title" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.currentSatisfactionAnalysis.title +
                                      " 滿意度表格分析"
                                  ) +
                                  " "
                              ),
                            ]),
                            _c(
                              "el-button",
                              {
                                staticClass: "download-pdf-btn",
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  icon: "el-icon-download",
                                },
                                on: { click: _vm.exportAnalysisTableToPDF },
                              },
                              [_vm._v(" 下載PDF報告 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                3631757234
              ),
            },
            [
              _c("analysis-table", {
                ref: "analysisTableRef",
                attrs: {
                  currentSatisfactionAnalysis: _vm.currentSatisfactionAnalysis,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.opinionSurveyPdfTopics.length > 0
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              staticClass: "abow_dialog",
              attrs: {
                id: "ansPdfModel",
                "append-to-body": "",
                title: "意見調查表填寫總覽",
                visible: _vm.dialogSurveyUserAnsStatisticsVisible,
                width: "60%",
                top: "1%",
                "data-role": "drag-drop-container",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogSurveyUserAnsStatisticsVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { ref: "capture", attrs: { id: "pdfCatch" } },
                [
                  _c("el-alert", {
                    staticStyle: { color: "#4b4b4b", "margin-bottom": "10px" },
                    attrs: {
                      title:
                        "分數說明，非常滿意:5分，滿意:4分，普通：3分，不太滿意:2分，非常不滿意：1分\n            (滿意度計算公式：個人答題總分除以選項類型題數)",
                      type: "warning",
                      effect: "dark",
                      closable: false,
                    },
                  }),
                  _vm.opinionSurveyPdfTopics &&
                  _vm.opinionSurveyPdfTopics.length > 0
                    ? _c(
                        "el-descriptions",
                        {
                          staticClass: "margin-top",
                          staticStyle: {
                            margin: "5px 0px",
                            border: "2px solid #ccc",
                          },
                          attrs: {
                            labelStyle: {
                              "text-align": "left",
                              "font-size": "12px",
                            },
                            contentStyle: { "text-align": "center" },
                            title: "",
                            column: 2,
                            size: "medium",
                            border: "",
                          },
                        },
                        [
                          _vm._l(_vm.opinionSurveyPdfTopics, function (d, di) {
                            return [
                              _c(
                                "el-descriptions-item",
                                { key: di },
                                [
                                  _c("template", { slot: "label" }, [
                                    _c("i", { staticClass: "el-icon-user" }),
                                    _vm._v(" " + _vm._s(d.title) + "(數量) "),
                                  ]),
                                  _c(
                                    "el-tag",
                                    { attrs: { size: "small" } },
                                    [
                                      _c("count-to", {
                                        staticClass: "card-panel-num",
                                        attrs: {
                                          "start-val": 0,
                                          "end-val": d.users.length,
                                          duration: 4600,
                                        },
                                      }),
                                      _vm._v("/" + _vm._s(d.userCount)),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                { key: di },
                                [
                                  _c("template", { slot: "label" }, [
                                    _c("i", { staticClass: "el-icon-tickets" }),
                                    _vm._v(
                                      " " + _vm._s(d.title) + "(整體滿意度) "
                                    ),
                                  ]),
                                  _c("el-tag", { attrs: { size: "small" } }, [
                                    _vm._v(
                                      " " + _vm._s(d.totalSatisfactionPoint)
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "el-scrollbar",
                    { staticClass: "page-component__scroll" },
                    [
                      _vm._l(
                        _vm.opinionSurveyPdfTopics,
                        function (item, index) {
                          return [
                            item.users.length
                              ? _c(
                                  "el-alert",
                                  {
                                    key: "l1_" + index,
                                    attrs: {
                                      close: "kind-desc",
                                      closable: false,
                                      type:
                                        item.kind == 2 ? "warning" : "success",
                                      effect: "dark",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _c("div", [_vm._v(_vm._s(item.title))]),
                                    ]),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._l(item.users, function (user, tindx) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: "l2_" + tindx + index,
                                    staticStyle: {
                                      border: "5px solid #ccc",
                                      padding: "20px 20px 0px",
                                      height: "100%",
                                      margin: "5px",
                                      "border-radius": "20px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-alert",
                                      {
                                        staticStyle: {
                                          margin: "5px 0px",
                                          "font-size": "14px",
                                        },
                                        attrs: {
                                          close: "kind-desc",
                                          type: "success",
                                          description:
                                            "填寫時間：" + user.replyDate,
                                          "show-icon": "",
                                          closable: false,
                                        },
                                      },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(tindx + 1) +
                                                "、【" +
                                                _vm._s(user.title) +
                                                "】" +
                                                _vm._s(user.userName) +
                                                " (" +
                                                _vm._s("分數：" + user.point) +
                                                "，" +
                                                _vm._s(
                                                  "滿意度：" +
                                                    user.satisfactionPoint
                                                ) +
                                                ") "
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "el-form",
                                      { attrs: { inline: false } },
                                      [
                                        _vm._l(
                                          user.topicList,
                                          function (item, index) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { key: "l3_" + index },
                                                [
                                                  [
                                                    item.required
                                                      ? _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              type: "info",
                                                              size: "mini",
                                                            },
                                                          },
                                                          [_vm._v("必填")]
                                                        )
                                                      : _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              type: "info",
                                                              size: "mini",
                                                            },
                                                          },
                                                          [_vm._v("非必填")]
                                                        ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(index + 1) +
                                                        "、 "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "12px",
                                                          color: "chocolate",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.topicType == 1
                                                              ? "單選題"
                                                              : "簡答題"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    !item.isDefault
                                                      ? _c("el-switch", {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "5px",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              item.hasAns,
                                                            "active-text":
                                                              "必填",
                                                            "inactive-text":
                                                              "非必填",
                                                          },
                                                          model: {
                                                            value:
                                                              item.required,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "required",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.required",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "el-row",
                                                      [
                                                        _c(
                                                          "el-col",
                                                          {
                                                            attrs: { span: 12 },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled:
                                                                  item.isDefault ||
                                                                  item.hasAns,
                                                              },
                                                              model: {
                                                                value:
                                                                  item.topicDescription,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "topicDescription",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.topicDescription",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    item.topicType == 1
                                                      ? [
                                                          item.topicCustomAnswer ==
                                                          0
                                                            ? [
                                                                _vm._l(
                                                                  item.options,
                                                                  function (
                                                                    op,
                                                                    opIndex
                                                                  ) {
                                                                    return [
                                                                      op.isSelected
                                                                        ? _c(
                                                                            "el-tag",
                                                                            {
                                                                              key: opIndex,
                                                                              staticStyle:
                                                                                {
                                                                                  margin:
                                                                                    "3px",
                                                                                  "font-size":
                                                                                    "16px",
                                                                                  border:
                                                                                    "1px solid #ffd643",
                                                                                  "background-origin":
                                                                                    "#fff4cb",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  type: "warning",
                                                                                  size: "medium",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  op.optionDescription
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      !op.isSelected
                                                                        ? _c(
                                                                            "el-tag",
                                                                            {
                                                                              key: opIndex,
                                                                              staticStyle:
                                                                                {
                                                                                  margin:
                                                                                    "3px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  type: "info",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  op.optionDescription
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  }
                                                                ),
                                                              ]
                                                            : _vm._e(),
                                                        ]
                                                      : _vm._e(),
                                                    item.topicType == 2
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "ans-text",
                                                              staticStyle: {
                                                                "margin-top":
                                                                  "5px",
                                                              },
                                                            },
                                                            [
                                                              _c("el-input", {
                                                                attrs: {
                                                                  disabled: "",
                                                                  value:
                                                                    item.ansText,
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                ],
                                                2
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            }),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          staticStyle: { height: "100%" },
          attrs: {
            id: "ansModel",
            "append-to-body": "",
            title: _vm.opinionSurveyTopics.title,
            visible: _vm.dialogSurveyQueryUserAnsVisible,
            width: "60%",
            top: "1%",
            "data-role": "drag-drop-container",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSurveyQueryUserAnsVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "20px",
                "padding-bottom": "0",
                height: "100%",
              },
            },
            [
              _c("el-alert", {
                staticStyle: { margin: "5px" },
                attrs: {
                  title: _vm.ansSurveyTopics.userName,
                  type: "success",
                  description: "填寫時間：" + _vm.ansSurveyTopics.replyDate,
                  "show-icon": "",
                  closable: false,
                },
              }),
              _c(
                "el-tag",
                { staticStyle: { position: "absolute", top: "0", left: "0" } },
                [
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.ansSurveyTopics.point,
                      duration: 4600,
                    },
                  }),
                  _vm._v("/ " + _vm._s(_vm.ansSurveyTopics.totalPoint)),
                ],
                1
              ),
              _c(
                "el-input",
                {
                  attrs: { placeholder: "請輸入表單標題", disabled: "" },
                  model: {
                    value: _vm.ansSurveyTopics.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.ansSurveyTopics, "title", $$v)
                    },
                    expression: "ansSurveyTopics.title",
                  },
                },
                [_c("template", { slot: "prepend" }, [_vm._v("表單標題")])],
                2
              ),
              _c(
                "el-form",
                { attrs: { inline: false } },
                [
                  _vm._l(_vm.ansSurveyTopics.topicList, function (item, index) {
                    return [
                      _c(
                        "el-form-item",
                        { key: index },
                        [
                          [
                            item.required
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "mini" } },
                                  [_vm._v("必填")]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "mini" } },
                                  [_vm._v("非必填")]
                                ),
                            _vm._v(" " + _vm._s(index + 1) + "， "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "chocolate",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.topicType == 1 ? "單選題" : "簡答題"
                                  )
                                ),
                              ]
                            ),
                            !item.isDefault
                              ? _c("el-switch", {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    disabled: item.hasAns,
                                    "active-text": "必填",
                                    "inactive-text": "非必填",
                                  },
                                  model: {
                                    value: item.required,
                                    callback: function ($$v) {
                                      _vm.$set(item, "required", $$v)
                                    },
                                    expression: "item.required",
                                  },
                                })
                              : _vm._e(),
                            _c("el-input", {
                              attrs: {
                                disabled: item.isDefault || item.hasAns,
                                size: "mini",
                              },
                              model: {
                                value: item.topicDescription,
                                callback: function ($$v) {
                                  _vm.$set(item, "topicDescription", $$v)
                                },
                                expression: "item.topicDescription",
                              },
                            }),
                            item.topicType == 1
                              ? [
                                  item.topicCustomAnswer == 0
                                    ? [
                                        _vm._l(
                                          item.options,
                                          function (op, opIndex) {
                                            return [
                                              op.isSelected
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      key: opIndex,
                                                      staticStyle: {
                                                        margin: "3px",
                                                        "font-size": "16px",
                                                        border:
                                                          "1px solid blue",
                                                      },
                                                      attrs: {
                                                        type: "success",
                                                        size: "medium",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          op.optionDescription
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              !op.isSelected
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      key: opIndex,
                                                      staticStyle: {
                                                        margin: "3px",
                                                      },
                                                      attrs: {
                                                        size: "mini",
                                                        type: "info",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          op.optionDescription
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            item.topicType == 2
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "ans-text" },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: "",
                                          value: item.ansText,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                        ],
                        2
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogSurveyQueryUserAnsVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          staticStyle: { height: "100%" },
          attrs: {
            "append-to-body": "",
            title: _vm.opinionSurveyTopics.title,
            visible: _vm.dialogSurveyQueryTopicVisible,
            width: "60%",
            top: "1%",
            id: "source-container",
            "data-role": "drag-drop-container",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSurveyQueryTopicVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "20px",
                "padding-bottom": "0",
                height: "100%",
              },
            },
            [
              _vm.opinionSurveyTopics.agencyCode
                ? _c(
                    "el-alert",
                    { attrs: { type: "warning", closable: false } },
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: true } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "表單標題" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "請輸入表單標題" },
                                model: {
                                  value: _vm.opinionSurveyTopics.title,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.opinionSurveyTopics,
                                      "title",
                                      $$v
                                    )
                                  },
                                  expression: "opinionSurveyTopics.title",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.opinionSurveyTopics.isSysDefault ||
                      _vm.opinionSurveyTopics.travelID == 0
                        ? _c(
                            "el-form",
                            { attrs: { inline: true } },
                            [
                              !_vm.opinionSurveyTopics.isSysDefault
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                      attrs: { label: "表單類型" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                "margin-right": "5px",
                                              },
                                              on: {
                                                change: _vm.handleKindChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.opinionSurveyTopics.kind,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.opinionSurveyTopics,
                                                    "kind",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "opinionSurveyTopics.kind",
                                              },
                                            },
                                            _vm._l(
                                              _vm.userKinds,
                                              function (item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _vm.opinionSurveyTopics.travelID != 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "padding-top": "5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox-group",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm
                                                              .opinionSurveyTopics
                                                              .kind == 1,
                                                          expression:
                                                            "opinionSurveyTopics.kind == 1",
                                                        },
                                                      ],
                                                      staticStyle: {
                                                        padding: "5px 15px",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.travelDefaultSelected,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.travelDefaultSelected =
                                                            $$v
                                                        },
                                                        expression:
                                                          "travelDefaultSelected",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.travelDefaultOptions,
                                                      function (option) {
                                                        return _c(
                                                          "el-checkbox",
                                                          {
                                                            key: option.name,
                                                            attrs: {
                                                              label:
                                                                option.value,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  option.name
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.opinionSurveyTopics.travelID == 0
                                ? _c(
                                    "el-form-item",
                                    { attrs: { label: "預設" } },
                                    [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-text": "設為預設",
                                          "active-value": true,
                                          "inactive-value": false,
                                          "inactive-text": "",
                                        },
                                        model: {
                                          value:
                                            _vm.opinionSurveyTopics.isDefault,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.opinionSurveyTopics,
                                              "isDefault",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "opinionSurveyTopics.isDefault",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form",
                        {
                          attrs: { inline: true },
                          model: {
                            value: _vm.newTopicData,
                            callback: function ($$v) {
                              _vm.newTopicData = $$v
                            },
                            expression: "newTopicData",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "題目文字" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.newTopicData.topicDescription,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newTopicData,
                                      "topicDescription",
                                      $$v
                                    )
                                  },
                                  expression: "newTopicData.topicDescription",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "是否必填" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-text": "必填",
                                  "inactive-text": "非必填",
                                },
                                model: {
                                  value: _vm.newTopicData.required,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newTopicData, "required", $$v)
                                  },
                                  expression: "newTopicData.required",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "題目類型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: { placeholder: "請選擇" },
                                  model: {
                                    value: _vm.newTopicData.newTopicOption,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newTopicData,
                                        "newTopicOption",
                                        $$v
                                      )
                                    },
                                    expression: "newTopicData.newTopicOption",
                                  },
                                },
                                _vm._l(_vm.topicTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "題組類型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  model: {
                                    value: _vm.defaultTopicGroup,
                                    callback: function ($$v) {
                                      _vm.defaultTopicGroup = $$v
                                    },
                                    expression: "defaultTopicGroup",
                                  },
                                },
                                _vm._l(
                                  _vm.groupOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.val,
                                        value: item.key,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-button", {
                            attrs: {
                              type: "warning",
                              circle: "",
                              icon: "el-icon-plus",
                              disabled: _vm.listLoading,
                            },
                            on: { click: _vm.addTopic },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form",
                {
                  staticStyle: {
                    "max-height": "calc(100vh - 350px)",
                    overflow: "auto",
                  },
                  attrs: { inline: false },
                },
                [
                  _vm._l(
                    _vm.opinionSurveyTopics.topicList,
                    function (item, index) {
                      return [
                        _c(
                          "el-form-item",
                          { key: index },
                          [
                            [
                              item.required
                                ? _c(
                                    "el-tag",
                                    { attrs: { type: "danger", size: "mini" } },
                                    [_vm._v("必填")]
                                  )
                                : _c(
                                    "el-tag",
                                    { attrs: { type: "info", size: "mini" } },
                                    [_vm._v("非必填")]
                                  ),
                              _vm._v(" " + _vm._s(index + 1) + "、 "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "chocolate",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.topicType == 1 ? "單選題" : "簡答題"
                                    )
                                  ),
                                ]
                              ),
                              !item.isDefault
                                ? _c("el-switch", {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      disabled: item.hasAns,
                                      "active-text": "必填",
                                      "inactive-text": "非必填",
                                    },
                                    model: {
                                      value: item.required,
                                      callback: function ($$v) {
                                        _vm.$set(item, "required", $$v)
                                      },
                                      expression: "item.required",
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    disabled: item.isDefault || item.hasAns,
                                  },
                                  model: {
                                    value: item.topicGroup,
                                    callback: function ($$v) {
                                      _vm.$set(item, "topicGroup", $$v)
                                    },
                                    expression: "item.topicGroup",
                                  },
                                },
                                _vm._l(
                                  _vm.groupOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.val,
                                        value: item.key,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                              !item.isDefault
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: {
                                        disabled: item.hasAns,
                                        type: "danger",
                                        size: "mini",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteTopic(index)
                                        },
                                      },
                                    },
                                    [_vm._v("刪除")]
                                  )
                                : _vm._e(),
                              _c("el-input", {
                                attrs: {
                                  disabled: item.isDefault || item.hasAns,
                                  size: "mini",
                                },
                                model: {
                                  value: item.topicDescription,
                                  callback: function ($$v) {
                                    _vm.$set(item, "topicDescription", $$v)
                                  },
                                  expression: "item.topicDescription",
                                },
                              }),
                              item.topicType == 1
                                ? [
                                    item.topicCustomAnswer == 0
                                      ? [
                                          _vm._l(
                                            item.options,
                                            function (op, opIndex) {
                                              return [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    key: opIndex,
                                                    staticStyle: {
                                                      margin: "3px",
                                                    },
                                                    attrs: { type: "info" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        op.optionDescription
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            }
                                          ),
                                        ]
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              !item.isDefault && item.hasAns
                                ? [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: { size: "mini", type: "danger" },
                                      },
                                      [
                                        _vm._v(
                                          "此題已有回覆，無法做任何異動調整"
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                          ],
                          2
                        ),
                      ]
                    }
                  ),
                  _vm._l(_vm.travelDefaultSelected, function (item, index) {
                    return [
                      _c(
                        "el-form-item",
                        { key: "travelDefaultSelected_" + index },
                        [
                          [
                            item.required
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [_vm._v("必填")]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "mini" } },
                                  [_vm._v("非必填")]
                                ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.opinionSurveyTopics.topicList.length +
                                    (index + 1)
                                ) +
                                "、 "
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "chocolate",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.topicType == 1 ? "單選題" : "簡答題"
                                  )
                                ),
                              ]
                            ),
                            !item.isDefault
                              ? _c("el-switch", {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    disabled: item.hasAns,
                                    "active-text": "必填",
                                    "inactive-text": "非必填",
                                  },
                                  model: {
                                    value: item.required,
                                    callback: function ($$v) {
                                      _vm.$set(item, "required", $$v)
                                    },
                                    expression: "item.required",
                                  },
                                })
                              : _vm._e(),
                            _c(
                              "el-select",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  disabled: item.isDefault || item.hasAns,
                                },
                                model: {
                                  value: item.topicGroup,
                                  callback: function ($$v) {
                                    _vm.$set(item, "topicGroup", $$v)
                                  },
                                  expression: "item.topicGroup",
                                },
                              },
                              _vm._l(_vm.groupOptions, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.val, value: item.key },
                                })
                              }),
                              1
                            ),
                            !item.isDefault
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      disabled: item.hasAns,
                                      type: "danger",
                                      size: "mini",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteTopic(index)
                                      },
                                    },
                                  },
                                  [_vm._v("刪除")]
                                )
                              : _vm._e(),
                            _c("el-input", {
                              attrs: {
                                disabled: item.isDefault || item.hasAns,
                                size: "mini",
                              },
                              model: {
                                value: item.topicDescription,
                                callback: function ($$v) {
                                  _vm.$set(item, "topicDescription", $$v)
                                },
                                expression: "item.topicDescription",
                              },
                            }),
                            item.topicType == 1
                              ? [
                                  item.topicCustomAnswer == 0
                                    ? [
                                        _vm._l(
                                          item.options,
                                          function (op, opIndex) {
                                            return [
                                              _c(
                                                "el-tag",
                                                {
                                                  key: opIndex,
                                                  staticStyle: {
                                                    margin: "3px",
                                                  },
                                                  attrs: { type: "info" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(op.optionDescription)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            !item.isDefault && item.hasAns
                              ? [
                                  _c(
                                    "el-tag",
                                    { attrs: { size: "mini", type: "danger" } },
                                    [_vm._v("此題已有回覆，無法做任何異動調整")]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                        ],
                        2
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: { click: _vm.saveTravelsOpinionSurveySetting },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogSurveyQueryTopicVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          staticStyle: { height: "100%" },
          attrs: {
            "append-to-body": "",
            top: _vm.dialogTopMargin,
            title: _vm.funcName + "維護",
            visible: _vm.dialogSurveyQueryVisible,
            width: "70%",
          },
          on: {
            opened: _vm.getAgencySurveyQueries,
            "update:visible": function ($event) {
              _vm.dialogSurveyQueryVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              staticClass: "box-card maintainCard",
              staticStyle: { height: "600px" },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  staticStyle: { position: "relative", height: "100%" },
                },
                [
                  _c(
                    "el-form",
                    { staticClass: "filter-form", attrs: { inline: true } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "選擇意見調查表" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                placeholder: "請選擇意見調查表",
                              },
                              model: {
                                value: _vm.agencySurveyQueryID,
                                callback: function ($$v) {
                                  _vm.agencySurveyQueryID = $$v
                                },
                                expression: "agencySurveyQueryID",
                              },
                            },
                            _vm._l(
                              _vm.agencySurveyQueryOptions,
                              function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.title,
                                    value: item.id,
                                    disabled: item.selected,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.agencySurveyQueryID
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "建立至旅遊團",
                                placement: "top",
                              },
                            },
                            [
                              _vm.agencySurveyQueryID
                                ? _c("el-button", {
                                    staticStyle: {
                                      "margin-top": "8px",
                                      "margin-left": "5px",
                                    },
                                    attrs: {
                                      type: "warning",
                                      circle: "",
                                      icon: "el-icon-plus",
                                      disabled: _vm.listLoading,
                                    },
                                    on: {
                                      click: _vm.createSurveyQueryToTravel,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-button", {
                        staticStyle: {
                          cursor: "pointer",
                          "margin-top": "8px",
                          "margin-left": "5px",
                        },
                        attrs: {
                          loading: _vm.listLoading,
                          type: "success",
                          icon: "el-icon-refresh-left",
                          circle: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.refresh(3)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-alert", {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: {
                      title:
                        "問卷使用對象為旅客及領隊，各自限定僅能填寫一份，未手動更改將顯示系統預設問卷。",
                      type: "error",
                      closable: false,
                    },
                  }),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        size: "mini",
                        data: _vm.opinionSurveies,
                        border: "",
                        height: "75%",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "title",
                          label: "意見調查表名稱",
                          width: "180",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "使用對象",
                          width: "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            row.kind == 1
                                              ? "success"
                                              : row.kind == 2
                                              ? "warning"
                                              : "primary",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            row.kind == 1
                                              ? "旅客"
                                              : row.kind == 2
                                              ? "領隊"
                                              : "旅行社"
                                          ) + " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "類型", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.isSysDefault
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "mini",
                                        },
                                      },
                                      [_vm._v("系統建立")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "維護", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "info" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getTravelsOpinionSurveyTopic(
                                          scope.row.id
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("維護")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "填寫名單",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "warning" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.confirmTravelsOpinionSurveyByOpinionSurveyID(
                                          scope.row.id
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("填寫名單")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "App使用",
                          width: "200",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-text": "設定為App使用",
                                        "active-value": true,
                                        "inactive-value": false,
                                        "active-color": "#13ce66",
                                        "inactive-color": "#ff4949",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.settingShowToApp(row)
                                        },
                                      },
                                      model: {
                                        value: row.showToApp,
                                        callback: function ($$v) {
                                          _vm.$set(row, "showToApp", $$v)
                                        },
                                        expression: "row.showToApp",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "表格分析",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getSatisfactionAnalysisDetails(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("表格分析")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "圖表分析",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getSatisfactionAnalysisChat(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("圖表分析")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "建立時間",
                          width: "170",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(row.buildDate) + " "),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "刪除", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                !row.isSysDefault
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteOpinionSurvery(
                                              row.id
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("刪除")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogSurveyQueryVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            "append-to-body": "",
            top: _vm.dialogTopMargin,
            title: "填寫名單",
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("el-card", { staticClass: "box-card" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticStyle: { position: "relative", height: "80%" },
              },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      size: "mini",
                      data: _vm.travelersReply,
                      border: "",
                      height: "400",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { align: "center", label: "項次", width: "60" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "userName",
                        label: "姓名",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "狀態", width: "200" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: row.isReply
                                          ? "success"
                                          : "danger",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.isReply ? "已填寫" : "未填寫"
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "填寫時間",
                        width: "200",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.replyDate
                                ? _c("span", [_vm._v(_vm._s(row.replyDate))])
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "查看", width: "200" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.isReply
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getAnReply(row)
                                            },
                                          },
                                        },
                                        [_vm._v("查看 ")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          staticStyle: { height: "100%", position: "relative" },
          attrs: { type: "border-card" },
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.device == "mobile",
                  expression: "device == 'mobile'",
                },
              ],
              staticStyle: {
                position: "absolute",
                right: "0%",
                top: "0",
                "z-index": "99",
              },
            },
            [
              _c("el-button", {
                attrs: {
                  type: "danger",
                  size: "small",
                  icon: _vm.showNotSatisfiedBoxCard
                    ? "el-icon-close"
                    : "el-icon-star-on",
                },
                on: {
                  click: function ($event) {
                    _vm.showNotSatisfiedBoxCard = !_vm.showNotSatisfiedBoxCard
                  },
                },
              }),
            ],
            1
          ),
          _c("el-tab-pane", { attrs: { label: "意見調查表", name: "1" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  position: "relative",
                  display: "flex",
                  gap: "0 12px",
                  width: "100%",
                  height: "100%",
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.device != "mobile" ||
                          (!_vm.showNotSatisfiedBoxCard &&
                            _vm.device == "mobile"),
                        expression:
                          "device != 'mobile' || (!showNotSatisfiedBoxCard && device == 'mobile')",
                      },
                    ],
                    staticStyle: { "min-width": "0", width: "100%" },
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticClass: "filter-form",
                        attrs: { inline: true },
                        nativeOn: {
                          submit: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "查詢" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "輸入團號/團名" },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.getAgencyTravelsAndOtherInformation(
                                    $event
                                  )
                                },
                              },
                              model: {
                                value: _vm.listQuery.qry,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "qry", $$v)
                                },
                                expression: "listQuery.qry",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("el-button", {
                          staticStyle: {
                            "margin-top": "8px",
                            "margin-left": "5px",
                          },
                          attrs: {
                            type: "primary",
                            icon: "el-icon-search",
                            circle: "",
                            disabled: _vm.listLoading,
                          },
                          on: {
                            click: _vm.getAgencyTravelsAndOtherInformation,
                          },
                        }),
                        _c("el-button", {
                          staticStyle: { cursor: "pointer" },
                          attrs: {
                            type: "success",
                            loading: _vm.listLoading,
                            circle: "",
                            icon: "el-icon-refresh-left",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.refresh(2)
                            },
                          },
                        }),
                        _vm.checkPermission([
                          "ITA-ADMIN",
                          "ITA-DEV",
                          "ITA-ADM-STAFF",
                          "ITA-SALES-ASSISTANT",
                          "ITA-BOSS",
                        ])
                          ? [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "line-height": "36px",
                                    color: "green",
                                    "text-align": "right",
                                  },
                                },
                                [
                                  _vm._v(" 總平均分數/總填寫份數："),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.averageAppSatisfactionPoint) +
                                        "(" +
                                        _vm._s(
                                          _vm.averageAppSatisfactionPointCount
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.listLoading,
                            expression: "listLoading",
                          },
                        ],
                        staticStyle: { position: "relative", height: "80%" },
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "mini",
                              data: _vm.list,
                              border: "",
                              height: "100%",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "項次",
                                width: "60",
                                fixed: "left",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.$index + 1)),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "tourGroupNo",
                                label: "團號",
                                width: "180",
                                align: "center",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "團名",
                                width: "400",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row.travelName)),
                                      ]),
                                      _c(
                                        "div",
                                        [
                                          _c("el-tag", [
                                            _vm._v(
                                              " 出發" +
                                                _vm._s(
                                                  row.beginDate +
                                                    " " +
                                                    row.beginTime
                                                ) +
                                                " - 回程" +
                                                _vm._s(
                                                  row.endDate +
                                                    " " +
                                                    row.endTime
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "維護與分析",
                                width: "130",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getAgencyTravelsOpinionSurveies(
                                                scope.row.id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("維護與分析")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "答題統計",
                                width: "130",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "warning",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getTravelsOpinionSurveyReplyAllDetails(
                                                scope.row.id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("答題統計")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "下載",
                                width: "130",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                            loading:
                                              _vm.currentDlPdfIDs.includes(
                                                scope.row.id
                                              ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getPdf(
                                                scope.row.id,
                                                scope.row.tourGroupNo +
                                                  "_" +
                                                  scope.row.travelName
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("下載PDF")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "下載",
                                width: "130",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                            loading:
                                              _vm.currentDlExcelIDs.includes(
                                                scope.row.id
                                              ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getExcel(
                                                scope.row.id,
                                                scope.row.tourGroupNo +
                                                  "_" +
                                                  scope.row.travelName
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("下載EXCEL")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "appSatisfactionPoint",
                                label: "APP滿意度",
                                width: "180",
                                align: "center",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.appSatisfactionPoint ==
                                              "0(0)"
                                              ? ""
                                              : scope.row.appSatisfactionPoint
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c("pagination", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.total > 0,
                              expression: "total > 0",
                            },
                          ],
                          attrs: {
                            layout: "prev, pager, next",
                            total: _vm.total,
                            page: _vm.listQuery.page,
                            limit: _vm.listQuery.limit,
                          },
                          on: {
                            "update:page": function ($event) {
                              return _vm.$set(_vm.listQuery, "page", $event)
                            },
                            "update:limit": function ($event) {
                              return _vm.$set(_vm.listQuery, "limit", $event)
                            },
                            pagination: _vm.getAgencyTravelsAndOtherInformation,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showNotSatisfiedBoxCard,
                        expression: "showNotSatisfiedBoxCard",
                      },
                    ],
                    staticStyle: {
                      width: "315px",
                      "flex-basis": "315px",
                      "flex-shrink": "0",
                      height: "100%",
                      "max-height": "100%",
                      "box-shadow": "0 2px 12px 0 rgba(0, 0, 0, 0.1)",
                      "overflow-y": "hidden",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-weight": "bold",
                          padding: "15px 8px",
                          color: "red",
                          "border-bottom": "1px solid #ddd",
                        },
                      },
                      [_vm._v(" 旅客填寫不滿意、非常不滿意 ")]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "8px",
                          height: "100%",
                          "max-height": "90%",
                          "overflow-y": "auto",
                        },
                      },
                      [
                        _c("not-satisfied-box-card", {
                          attrs: { limit: 50, "show-header": false },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _c("el-tab-pane", { attrs: { label: "表單設計", name: "2" } }, [
            _c(
              "div",
              { staticClass: "full-height" },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "filter-form",
                    attrs: { inline: true },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "查詢" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "輸入團號/團名" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.getAgencyOpinionSurvey($event)
                            },
                          },
                          model: {
                            value: _vm.agencyListQuery.qry,
                            callback: function ($$v) {
                              _vm.$set(_vm.agencyListQuery, "qry", $$v)
                            },
                            expression: "agencyListQuery.qry",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-button", {
                      staticStyle: {
                        "margin-top": "8px",
                        "margin-left": "5px",
                      },
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        circle: "",
                        disabled: _vm.listLoading,
                      },
                      on: { click: _vm.getAgencyOpinionSurvey },
                    }),
                    _c("el-button", {
                      attrs: {
                        type: "warning",
                        circle: "",
                        icon: "el-icon-plus",
                        disabled: _vm.listLoading,
                      },
                      on: { click: _vm.addData },
                    }),
                    _c("el-button", {
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        type: "success",
                        loading: _vm.listLoading,
                        circle: "",
                        icon: "el-icon-refresh-left",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.refresh(1)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    staticStyle: { position: "relative", height: "90%" },
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          size: "mini",
                          data: _vm.agencyOpinionSurveies,
                          border: "",
                          height: "100%",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "項次",
                            width: "60",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.$index + 1)),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "title",
                            label: "意見調查表名稱",
                            width: "180",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "意見調查表類型",
                            width: "130",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type:
                                              row.kind == 1
                                                ? "success"
                                                : "warning",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              row.kind == 1 ? "旅客" : "領隊"
                                            ) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "預設",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-text": "設為預設",
                                      "active-value": true,
                                      "inactive-value": false,
                                      "inactive-text": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.triggerDefault(scope.row)
                                      },
                                    },
                                    model: {
                                      value: scope.row.isDefault,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "isDefault", $$v)
                                      },
                                      expression: "scope.row.isDefault",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "意見調查表維護",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "info" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getTravelsOpinionSurveyTopic(
                                            scope.row.id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("意見調查表維護")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "建立時間",
                            width: "200",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-tag",
                                        { attrs: { type: "info" } },
                                        [_vm._v(_vm._s(row.buildDate) + " ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "刪除",
                            width: "200",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "danger",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteOpinionSurvery(
                                                row.id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("刪除")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c("pagination", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.agencyTotal > 0,
                          expression: "agencyTotal > 0",
                        },
                      ],
                      staticStyle: { "padding-top": "0" },
                      attrs: {
                        layout: "prev, pager, next",
                        total: _vm.total,
                        page: _vm.agencyListQuery.page,
                        limit: _vm.agencyListQuery.limit,
                      },
                      on: {
                        "update:page": function ($event) {
                          return _vm.$set(_vm.agencyListQuery, "page", $event)
                        },
                        "update:limit": function ($event) {
                          return _vm.$set(_vm.agencyListQuery, "limit", $event)
                        },
                        pagination: _vm.getAgencyOpinionSurvey,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }